import { Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import HtmlParser from 'html-react-parser';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { DistributionUploadStatus, IDistributionFile } from '../../../models';

export const DistributionUploadStatusMessageContainer = styled.div`
	text-align: left;
	margin-top: 10px;
	margin-bottom: 10px;
`;
DistributionUploadStatusMessageContainer.displayName = 'DistributionUploadStatusMessageContainer';

export interface IDistributionUploadStatusMessageProps {
	selectedDistribution?: IDistributionFile;
	distributions?: IDistributionFile[];
}

export class DistributionUploadStatusMessage extends React.Component<IDistributionUploadStatusMessageProps, {}> {
	constructor(props: IDistributionUploadStatusMessageProps) {
		super(props);
	}

	public render() {
		const message = this.getMessage();
		const warningMessage = this.getWarningMessage();
		const pullOutType = this.getPulloutType(warningMessage);

		return (
			<DistributionUploadStatusMessageContainer className='tws-distribution-upload-status-container'>
				{message && (
					<Pullout type={pullOutType}>
						{HtmlParser('<b>' + warningMessage + '</b>: ')}
						{message}
					</Pullout>
				)}
			</DistributionUploadStatusMessageContainer>
		);
	}

	private getWarningMessage() {
		const { distributions, selectedDistribution } = this.props;

		if (selectedDistribution) {
			if (selectedDistribution.distributionUploadStatusId === DistributionUploadStatus.Failed) {
				return ContentConstants.ERROR;
			} else if (selectedDistribution.distributionUploadStatusId !== DistributionUploadStatus.Completed) {
				return ContentConstants.WARNING;
			}
		} else if (distributions) {
			if (distributions.filter((d) => d.distributionUploadStatusId === DistributionUploadStatus.Failed).length > 0) {
				return ContentConstants.ERROR;
			} else if (!distributions.every((d) => d.distributionUploadStatusId === DistributionUploadStatus.Completed)) {
				return ContentConstants.WARNING;
			}
		}
		return null;
	}

	private getMessage() {
		const { distributions, selectedDistribution } = this.props;

		if (selectedDistribution) {
			switch (selectedDistribution.distributionUploadStatusId) {
				case DistributionUploadStatus.Failed:
					return ContentConstants.INSTRUCTIONALTEXT_DISTRIBUTION_UPLOAD_FAILED.replace('{fileName}', selectedDistribution.fileName);
				case DistributionUploadStatus.InProgress:
					return ContentConstants.INSTRUCTIONALTEXT_DISTRIBUTION_UPLOAD_INPROGRESS;
				case DistributionUploadStatus.NotStarted:
					return ContentConstants.INSTRUCTIONALTEXT_DISTRIBUTION_UPLOAD_NOTSTARTED.replace(
						'{fileName}',
						selectedDistribution.fileName,
					).replace('{contactsCount}', selectedDistribution.contactsCount.toString());
			}
		} else {
			const failedDistribution = _.find(distributions, (d: IDistributionFile) => {
				return d.distributionUploadStatusId === DistributionUploadStatus.Failed;
			});
			const inProgressDistribution = _.find(distributions, (d: IDistributionFile) => {
				return d.distributionUploadStatusId === DistributionUploadStatus.InProgress;
			});
			const notStartedDistribution = _.find(distributions, (d: IDistributionFile) => {
				return d.distributionUploadStatusId === DistributionUploadStatus.NotStarted;
			});

			if (failedDistribution) {
				const message = ContentConstants.INSTRUCTIONALTEXT_DISTRIBUTION_UPLOAD_FAILED.replace('{fileName}', failedDistribution.fileName);

				return (
					<>
						{message} {failedDistribution.uploadFailureReason && <p>{failedDistribution.uploadFailureReason}</p>}
					</>
				);
			}
			if (inProgressDistribution || notStartedDistribution) {
				return ContentConstants.INSTRUCTIONALTEXT_DISTRIBUTION_UPLOAD_INPROGRESS;
			}
		}
		return null;
	}

	private getPulloutType(warningMessage: string | null) {
		if (warningMessage === ContentConstants.WARNING) {
			return PulloutType.Warning;
		} else if (warningMessage === ContentConstants.ERROR) {
			return PulloutType.Error;
		} else {
			return PulloutType.Note;
		}
	}
}
